<template>
  <div class="home">
    <HeadBar title="首页" needBack="false" />
    <!-- gif 图 -->
    <van-image v-if="topGif.imageUrl" fit="contain" lazy-load :src="topGif.imageUrl" alt="长春疯马体育" class="divBlock" />
    <!-- 焦点图 -->
    <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
      <van-swipe-item v-for="(item, index) in images" :key="index">
        <a :href="item.url" target="_self" rel="noopener noreferrer">
          <van-image fit="contain" lazy-load :src="item.imageUrl" alt="长春疯马体育" />
        </a>
      </van-swipe-item>
    </van-swipe>
    <!-- 功能模块 -->
    <FunctionBar :funObj="funObj"></FunctionBar>

    <div class="countdown-box" id="J_countDown" v-if="ifShowCountDown">
      <ul class="matchTimeBox">
        <li>
          <span id="J_day" class="time-box"> 00 </span>
          <span class="font14">天</span>
        </li>
        <li>
          <span id="J_hours" class="time-box"> 00 </span>
          <span class="font14">时</span>
        </li>
        <li>
          <span id="J_minutes" class="time-box"> 00 </span>
          <span class="font14">分</span>
        </li>
        <li>
          <span id="J_seconds" class="time-box"> 00 </span>
          <span class="font14">秒</span>
        </li>
      </ul>
      <div class="matchNameBox">{{ matchName }}</div>
    </div>

    <!-- 赛事活动 -->
    <ItemTitle title="赛事活动" href="/gameList" :needMore="true"></ItemTitle>
    <GamaList :gameList="gameList" :fromIndex="true"></GamaList>

    <!-- 新闻公告 -->
    <ItemTitle v-if="newsList && newsList.length > 0" title="新闻公告" href="/newsList" :needMore="true"></ItemTitle>
    <NewsList :newsList="newsList"></NewsList>

    <!-- <ItemTitle title="报名查询"></ItemTitle>
    <ApplySearch :submitUrl="'/searchList'"></ApplySearch>

    <ItemTitle title="成绩查询"></ItemTitle>
    <ScoreSearch :submitUrl="'/scoreSearch'"></ScoreSearch> -->

    <!-- 赛事专供 -->
    <ItemTitle title="赛事专供" :needMore="false"></ItemTitle>
    <AdList :adData="adData"></AdList>

    <!-- 冠名商logo -->
    <ItemTitle v-if="zanzhuLogo1 && zanzhuLogo1.length > 0" title="冠名赞助商" :needMore="false"></ItemTitle>
    <LogoList :logoList="zanzhuLogo1"></LogoList>

    <!-- 冠名商logo -->
    <ItemTitle v-if="zanzhuLogo2 && zanzhuLogo2.length > 0" title="顶级合作伙伴" :needMore="false"></ItemTitle>
    <LogoList :logoList="zanzhuLogo2"></LogoList>

    <!-- 冠名商logo -->
    <ItemTitle v-if="zanzhuLogo3 && zanzhuLogo3.length > 0" title="官方合作伙伴" :needMore="false"></ItemTitle>
    <LogoList :logoList="zanzhuLogo3"></LogoList>

    <!-- 冠名商logo -->
    <ItemTitle v-if="zanzhuLogo4 && zanzhuLogo4.length > 0" title="官方赞助商" :needMore="false"></ItemTitle>
    <LogoList :logoList="zanzhuLogo4"></LogoList>

    <!-- 冠名商logo -->
    <ItemTitle v-if="zanzhuLogo5 && zanzhuLogo5.length > 0" title="赛事支持商" :needMore="false"></ItemTitle>
    <LogoList :logoList="zanzhuLogo5"></LogoList>

    <!-- 版权相关 -->
    <BottomBar></BottomBar>
  </div>
</template>

<script>
  import HeadBar from "@/components/HeadBar.vue";
  import FunctionBar from "@/components/FunctionBar.vue";
  import GamaList from "@/components/GamaList.vue";
  import NewsList from "@/components/NewsList.vue";
  import AdList from "@/components/AdList.vue";
  import LogoList from "@/components/LogoList.vue";
  import BottomBar from "@/components/BottomBar.vue";
  import ItemTitle from "@/components/ItemTitle.vue";
  import ApplySearch from "@/components/ApplySearch.vue";
  import ScoreSearch from "@/components/ScoreSearch.vue";
  import { fetchHttp, formatTime } from "@/util/fn.js";

  import { Toast, Button, Swipe, SwipeItem, Image as VanImage } from "vant";
  export default {
    name: "Home",
    components: {
      HeadBar,
      [Button.name]: Button,
      [Swipe.name]: Swipe,
      [SwipeItem.name]: SwipeItem,
      [VanImage.name]: VanImage,
      FunctionBar,
      GamaList,
      NewsList,
      AdList,
      LogoList,
      BottomBar,
      // ApplySearch,
      // ScoreSearch,
      ItemTitle,
    },
    data() {
      return {
        matchName: "",
        matchTime: "2020/06/01,12:00:00",
        topGif: "",
        gameList: [],
        newsList: [],
        zanzhuLogo1: [],
        zanzhuLogo2: [],
        zanzhuLogo3: [],
        zanzhuLogo4: [],
        zanzhuLogo5: [],

        adData: [
          // {title:'测试1',url:'', pictureUrl:'http://ccfmty.com/marathon/%E9%A9%AC%E6%8B%89%E6%9D%BE/3a349a3df9ed4ffb8b06faeab7499e58.jpg' },
        ],
        images: [],
        funObj: [
          {
            text: "报名查询",
            icon: "award",
            href: "searchList",
          },
          {
            text: "成绩查询",
            icon: "star",
            href: "ScoreSearch",
          },
          {
            text: "赛事中心",
            icon: "volume",
            href: "gameList",
          },
          {
            text: "照片查询",
            icon: "photo",
            href: "newsDetail?newsId=34",
          },
        ],
      };
    },
    created() { },
    mounted() {
      //倒计时
      fetchHttp("marathon/picture/matchTime", { type: 5, domain: 0 }, "GET").then(
        (res) => {
          if (res && res.code === 0) {
            let data = res.data;
            if (data) {
              this.matchName = data.matchName;
              this.matchTime = data.matchTime;

              let matchTime = data.matchTime;

              setTimeout(() => {
                countDown();
              }, 2000);

              function addZero(i) {
                return i < 10 ? "0" + i : i + "";
              }
              function countDown() {
                var nowtime = new Date();
                var endtime = new Date(matchTime);
                if (nowtime > endtime) {
                  // document.getElementById('J_countDown').style.display = 'none';
                  return;
                }
                var lefttime = parseInt(
                  (endtime.getTime() - nowtime.getTime()) / 1000
                );
                var d = parseInt(lefttime / (24 * 60 * 60));
                var h = parseInt((lefttime / (60 * 60)) % 24);
                var m = parseInt((lefttime / 60) % 60);
                var s = parseInt(lefttime % 60);
                d = addZero(d);
                h = addZero(h);
                m = addZero(m);
                s = addZero(s);
                if (document.getElementById("J_day")) {
                  document.getElementById("J_day").innerHTML = d;
                  document.getElementById("J_hours").innerHTML = h;
                  document.getElementById("J_minutes").innerHTML = m;
                  document.getElementById("J_seconds").innerHTML = s;
                }
                setTimeout(countDown, 1000);
              }
            }
          }
        }
      );

      //顶部的gif
      fetchHttp("marathon/picture/topPicture", { type: 2 }, "GET").then((res) => {
        if (res && res.code === 0) {
          this.topGif = res.data && res.data.length > 0 ? res.data[0] : "";
        }
      });

      //首页焦点图模块
      fetchHttp("marathon/picture/homePage", { domain: 0 }, "GET").then((res) => {
        if (res && res.code === 0) {
          let originData = res.data;
          originData.map((item, index) => {
            if (item.url.indexOf("gameDetail.html?id=") > -1) {
              let id = item.url.split("gameDetail.html?id=")[1];
              item.url = "gameDetail?matchId=" + id;
            }
          });
          this.images = originData;
        } else {
          //默认两张图
          this.images = [
            {
              url: "",
              imageUrl:
                "http://ccfmty.com/marathon/%E9%A9%AC%E6%8B%89%E6%9D%BE/3a349a3df9ed4ffb8b06faeab7499e58.jpg",
            },
            {
              url: "",
              imageUrl:
                "http://ccfmty.com/marathon/%E9%A9%AC%E6%8B%89%E6%9D%BE/64f00303d6c14f8d8a40b624fc8d4a58.png",
            },
          ];
        }
      });

      //首页赛事模块
      fetchHttp("marathon/match/information?domain=0", "POST").then((res) => {
        if (res && res.code === 0) {
          const dataList = res && res.data;
          let doing = [];
          let done = [];
          let lastData = [];
          dataList &&
            dataList.length > 0 &&
            dataList.forEach((item, index) => {
              item.startTime = formatTime(item.startTime);
              item.endTime = formatTime(item.endTime);
              item.matchTime = formatTime(item.matchTime);
              if (!item.matchName.includes("测试赛")) {
                if (item.state === 4) {
                  done.push(item);
                } else {
                  doing.push(item);
                }
              }
            });
          lastData = doing.concat(done);
          this.gameList = lastData.slice(0, 4);
        }
      });

      //首页新闻模块
      fetchHttp("marathon/newsHomePage", "POST").then((res) => {
        if (res && res.code === 0) {
          let newsList = res.data;
          let renderList = [];
          newsList.map((item, index) => {
            var newsContent = item.newsContent;
            item.newsContent = newsContent.replace(/<[^>]+>|&[^>]+;|(\n)/g, "");
            item.domain === 0 ? renderList.push(item) : "";
          });
          this.newsList = renderList;
        }
      });

      //首页赞助商logo
      fetchHttp("marathon/picture/logo", "POST").then((res) => {
        if (res && res.code === 0) {
          let logoData = res.data;
          logoData.map((item) => {
            if (item.logoType === 1) {
              this.zanzhuLogo1.push(item);
            }

            if (item.logoType === 2) {
              this.zanzhuLogo2.push(item);
            }

            if (item.logoType === 3) {
              this.zanzhuLogo3.push(item);
            }

            if (item.logoType === 4) {
              this.zanzhuLogo4.push(item);
            }

            if (item.logoType === 5) {
              this.zanzhuLogo5.push(item);
            }
          });
        }
      });

      //首页赛事专供
      fetchHttp("marathon/picture/wonderfulPicture", { type: 4 }, "GET").then(
        (res) => {
          if (res && res.code === 0) {
            this.adData = res.data;
          }
        }
      );
    },
    computed: {
      ifShowCountDown() {
        if (+new Date() - +new Date(this.matchTime) > 0) {
          return false;
        } else {
          return true;
        }
      },
    },

    methods: {
      onSubmit() {
        Toast("首页");
      },
    },
  };
</script>
<style scope lang="less">
  .home {
    text-align: center;
    color: #fff;
  }

  .my-swipe {
    min-height: 10px;

    .van-image__img {
      width: 100%;
      min-height: 150px;
    }
  }

  .my-swipe .van-swipe-item {
    text-align: center;
    width: 100%;
    min-height: 136px;
  }

  .countdown-main {
    background-color: #e50021;
    color: #ffffff;
    margin: 0 0 10px 0;
    position: absolute;
    right: 0;
    bottom: 0;
  }

  .divBlock {
    display: block;
  }

  .countdown-name {
    float: left;
    font-size: 20px;
    font-weight: 300;
    margin: 0 20px 0 10px;
    line-height: 40px;
  }

  .time-box {
    background-color: #000000;
    color: #ffffff;
    font-weight: 1000;
    margin-right: 10px;
    border-radius: 4px;
    width: 35px;
    height: 32px;
    display: inline-block;
    line-height: 33px;
    text-align: center;
  }

  .font14 {
    color: #fff;
  }

  .countdown-box {
    padding: 10px 0;
    width: 100%;
    color: #fff;
    font-size: 20px;
    float: left;
    margin: 1px 0px 10px 0;
    text-align: center;
    background: #e50021;

    li {
      float: left;
      margin: 0px 5px 0;
      text-align: center;
      padding-top: 2px;
      line-height: 0;
      font-size: 23px;
      font-family: initial;

      p {
        margin: 15px 0;
      }
    }
  }

  .matchTimeBox {
    display: flex;
    justify-content: center;
  }

  .matchNameBox {
    font-size: 16px;
    color: #fff;
    margin-top: 10px;
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    padding: 0 10px;
  }
</style>